// extracted by mini-css-extract-plugin
export default {"notice":"jlptNotice_notice__61yWR"};